<template>
  <div >
    <datepicker :state="datepickerState" ref="pickFrom" v-on:datepicker-date-picked="onDatePicked"></datepicker>
    <b-container fluid class="md-content">
        <b-row>
            <b-col cols="5">
            </b-col>
            <b-col cols="2" class="md-header">
                Events & Feiertage 
            </b-col>
            <b-col cols="5">
                <b-button v-on:click="toggleDatePicker()">{{monthDisplay}}</b-button>
            </b-col>
        </b-row>
        
       
        <br>
        <b-card>
            <b-row>
                
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createstoreevent')">Event anlegen</b-button>
                </b-col>
                 <b-col>
                    <b-button variant="success" @click="showModal('modal-createholidays')">Feiertage anlegen</b-button>
                </b-col>
                <b-col v-if="selectedStoreEvents.length > 0">
                    <b-button variant="danger" @click="showModal('modal-deletemultistoreevent')"> {{selectedStoreEvents.length}} Events löschen</b-button>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="storeevents != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="storeevents" :fields="fields" selectable select-mode="range" @row-selected="updateSelectedStoreEvents">
                        <template slot="federalHoliday" slot-scope="row">
                            <i v-bind:class="{'fas fa-check': row.item.federalHoliday, 'fas fa-times': !row.item.federalHoliday}"></i>
                        </template>
                        <template slot="bankHoliday" slot-scope="row">
                            <i v-bind:class="{'fas fa-check': row.item.bankHoliday, 'fas fa-times': !row.item.bankHoliday}"></i>
                        </template>
                        <template slot="active" slot-scope="row">
                            <i v-bind:class="{'fas fa-check': row.item.active, 'fas fa-times': !row.item.active}"></i>
                        </template>
                        <template slot="from" slot-scope="row">
                            {{formattedTimeMap[row.item.id].from}}
                        </template>
                        <template slot="to" slot-scope="row">
                            {{formattedTimeMap[row.item.id].to}}
                        </template>
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openEditModal(row)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="success" v-if="!row.item.active" v-on:click="activateStoreEvent(row.item.id)"><i class="fas fa-arrow-alt-circle-up"></i></b-button> 
                            <b-button class="mx-1" size="sm" v-if="row.item.active" variant="warning" v-on:click="deactivateStoreEvent(row.item.id)"><i class="fas fa-stop-circle"></i></b-button>    
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
      
    </b-container>

    <b-modal ref="modal-viewstoreevent"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Event Detail" @cancel="hideModal('modal-viewstoreevent')" @ok="hideModal('modal-viewstoreevent')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            
            <div v-if="storeEventId != null && storeEventMap[storeEventId] != undefined">
                <b-row>
                           
                    <b-col class="md-2">
                            <b>Name:</b> 
                    </b-col>
                    <b-col >
                            {{storeEventMap[storeEventId].name}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="md-2">
                            <b>Von:</b> 
                    </b-col>
                    <b-col >
                            {{formattedTimeMap[storeEventId].from}}
                    </b-col>
                    <b-col class="md-2">
                            <b>Bis:</b> 
                    </b-col>
                    <b-col >
                            {{formattedTimeMap[storeEventId].to}}
                    </b-col>
                </b-row>
                <b-row>      
                    <b-col class="md-2">
                            <b>Gesetzlicher Feiertag:</b> 
                    </b-col>
                    <b-col >
                            {{storeEventMap[storeEventId].federalHoliday}}
                    </b-col>
                    <b-col class="md-2">
                            <b>Banken Feiertag:</b> 
                    </b-col>
                    <b-col >
                            {{storeEventMap[storeEventId].bankHoliday}}
                    </b-col>
                </b-row>
                <b-row>      
                    <b-col class="md-2">
                            <b>Beschreibung:</b> 
                    </b-col>
                    <b-col >
                            {{storeEventMap[storeEventId].description}}
                    </b-col>
                </b-row>
            </div>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-createstoreevent"  no-close-on-backdrop no-close-on-esc centered title="Event anlegen" @cancel="hideModal('modal-createstoreevent')" @ok="createStoreEvent" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="4" label="Name" label-for="newbuname">
                    <b-form-input id="newbuname" v-model="storeEvent.name"></b-form-input>
                </b-form-group>
                
                <b-form-group label-cols="4" label-cols-lg="4" label="Datum von" label-for="css3">
                    <b-form-input id="css3" v-model="storeEvent.fromDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="css4">
                    <b-form-input id="css4" v-model="storeEvent.fromTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum bis" label-for="css5">
                    <b-form-input id="css5" v-model="storeEvent.toDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="css6">
                    <b-form-input id="css6" v-model="storeEvent.toTime" type="time"></b-form-input>
                </b-form-group>
                
                <b-form-group label-cols="4" label-cols-lg="4" label="Gesetzlicher Feiertag" label-for="federalcheck">
                     <b-form-checkbox id="federalcheck" v-model="storeEvent.federalHoliday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Banken Feiertag" label-for="bankcheck">
                     <b-form-checkbox id="bankcheck" v-model="storeEvent.bankHoliday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Beschreibung" label-for="css11">
                    <b-form-input id="css11" v-model="storeEvent.description" type="text"></b-form-input>
                </b-form-group>
            </div>
            
            
        </b-container>
    </b-modal>

    <b-modal ref="modal-createholidays"  no-close-on-backdrop no-close-on-esc centered title="Feiertage anlegen" @cancel="hideModal('modal-createholidays')" @ok="createHolidays" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="4" label="Jahr" label-for="year">
                    <b-form-input min=0 id="newbuname" v-model.number="holidayYear"></b-form-input>
                </b-form-group>
            </div>
            
            
        </b-container>
    </b-modal>

    <b-modal ref="modal-editstoreevent"  no-close-on-backdrop no-close-on-esc centered title="Event bearbeiten" @cancel="hideModal('modal-editstoreevent')" @ok="editStoreEvent" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="4" label="Name" label-for="newbuname">
                    <b-form-input id="newbuname" v-model="storeEvent.name"></b-form-input>
                </b-form-group>
                
                <b-form-group label-cols="4" label-cols-lg="4" label="Datum von" label-for="css3">
                    <b-form-input id="css3" v-model="storeEvent.fromDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="css4">
                    <b-form-input id="css4" v-model="storeEvent.fromTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum bis" label-for="css5">
                    <b-form-input id="css5" v-model="storeEvent.toDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="css6">
                    <b-form-input id="css6" v-model="storeEvent.toTime" type="time"></b-form-input>
                </b-form-group>
                
                <b-form-group label-cols="4" label-cols-lg="4" label="Gesetzlicher Feiertag" label-for="federalcheck">
                     <b-form-checkbox id="federalcheck" v-model="storeEvent.federalHoliday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Banken Feiertag" label-for="bankcheck">
                     <b-form-checkbox id="bankcheck" v-model="storeEvent.bankHoliday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Beschreibung" label-for="css11">
                    <b-form-input id="css11" v-model="storeEvent.description" type="text"></b-form-input>
                </b-form-group>
            </div>
            
           
        </b-container>
    </b-modal>
    
    <b-modal ref="modal-deletestoreevent"  no-close-on-backdrop no-close-on-esc centered title="Event löschen" @cancel="hideModal('modal-deletestoreevent')" @ok="deleteStoreEvent" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie das Event löschen wollen?</p>
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deletemultistoreevent"  no-close-on-backdrop no-close-on-esc centered title="Event löschen" @cancel="hideModal('modal-deletemultistoreevent')" @ok="multiDeleteStoreEvent" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die {{selectedStoreEvents.length}} Events löschen wollen?</p>
            </b-row>
        </b-container>
    </b-modal>

  </div>

</template>

<script>
import datepicker from '../uicomponents/datepicker.vue'
export default {
  name: 'storeeventoverview',
  components: {
      datepicker
  },
  data () {
    return {
      storeevents: [],
      selectedStoreEvents: [],
      storeEventMap: {},
      storeEventId: null,
      fields: [{key:"name", label: "Name", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, {key: "from", label: "Von", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, 
               {key: "to", label: "Bis", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, 
               {key: "federalHoliday", label: "Gestezlicher Feiertag", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, 
               {key: "bankHoliday", label: "Banken Feiertag", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, 
               {key: "active", label: "Aktiv", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"actions",label: "", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      currentrow: {},
      storeEvent: {
          name: "",
          fromDate: null,
          fromTime: null,
          toDate: null,
          toTime: null,
          federalHoliday: false,
          bankHoliday: false,
          active: true,
          desription: ""
      },
      dateSelectionStart: this.$helpers.getCurrentMonthMomentUTC(),
      datepickerState: {
            toggled: false,
            monthView: true,
            dayViewAllowed: false,
            yearViewAllowed: false,
            posx: window.mouse.x,
            posy: window.mouse.y,
            date: this.$helpers.getCurrentMonthMomentUTC(),
            selectedDate: this.$helpers.getCurrentMonthMomentUTC()
      },
      holidayYear: this.$helpers.getCurrentMonthMomentUTC().year(),
      
    }
  },
  created: function () {
    this.setDateSelection(this.$helpers.getCurrentMonthMomentUTC(), true);
    
  },
  computed: {
        formattedTimeMap() {
          let map = {}
          for(let i = 0; i<this.storeevents.length; i++){
              let event = this.storeevents[i];
              map[event.id] =  { from: this.$helpers.getMomentFromString(event.from).format("DD.MM.YYYY HH:mm"), 
                                 to: this.$helpers.getMomentFromString(event.to).format("DD.MM.YYYY HH:mm")}
          }
          return map;
        },
        rosterFromTo() {
            if(this.$store.state.loggedIn){
                return this.$store.state.rosterFromTo;
            } else {
                return null;
            }    
        },
        storeId() {
            return this.$store.state.storeId;
        },
        monthDisplay: function() {
            if(this.dateSelectionStart != null){
                return this.dateSelectionStart.format('MMM YYYY');
            } else {
                '-';
            }
                
        },
  },
  watch: {
    rosterFromTo(newVal, oldVal) {
        if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    storeId(newVal, oldVal) {
        console.log("Changed storeId: "+newVal);
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function() {
        let view = this;
        this.selectedStoreEvents = [];
        this.loadStoreEvents()
        .then(response=>{
            view.updateStoreEvents(response.data) 
        })
        .catch(function (error) {
            console.log(error)
        });
    },
    toggleDatePicker() {
        
        this.datepickerState = {
            toggled: true,
            monthView: true,
            yearViewAllowed: false,
            dayViewAllowed: false,
            posx: window.mouse.x,
            posy: window.mouse.y,
            date: this.dateSelectionStart,
            selectedDate: this.dateSelectionStart
        };
    },
    setDateSelection(date, calculateRosterFromTo){
        this.dateSelectionStart = date.clone(); 
                
        if(calculateRosterFromTo){
            //update vuex store with calculated from to => triggers reload of data via refresh
            
            let rosterFromTo = {
                month: this.dateSelectionStart.month(),
                from: this.dateSelectionStart.clone().startOf('isoWeek').format(),
                to: this.dateSelectionStart.clone().endOf('month').endOf('isoWeek').add(1,'weeks').startOf('isoWeek').format(),
            };
            this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
        } else {
            //dont update vuex from to, only update client side view
        }
    },
    onDatePicked(date){        
        this.setDateSelection(date, true);
    },
    updateSelectedStoreEvents(items) {
        this.selectedStoreEvents = items
    },
    createStoreEvent: function(evt){
        evt.preventDefault();
        
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
          name: this.storeEvent.name,
          from: this.$helpers.convertLocalDateTimeString(this.storeEvent.fromDate, this.storeEvent.fromTime),
          to: this.$helpers.convertLocalDateTimeString(this.storeEvent.toDate, this.storeEvent.toTime),
          federalHoliday: this.storeEvent.federalHoliday,
          bankHoliday: this.storeEvent.bankHoliday,
          description: this.storeEvent.description,
        };

        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.storeEventMap[response.data.data.id] = response.data.data;
           
            view.storeevents.push(response.data.data);
            view.hideModal('modal-createstoreevent');
        }).catch(function (error) {
            window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Fehler', description: 'Fehler beim Erstellen!'});
            console.log(error)
        })

    },
    createHolidays: function(evt){
        evt.preventDefault();
        
        let view = this;
        let url = '/api/sec/storeevent/holidays/default';
        
        let params = {
            storeId: this.$store.state.storeId,
            years: this.holidayYear
        };
        

        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
        }).then(response => {
            view.refresh();
            view.hideModal('modal-createholidays');
        }).catch(function (error) {
            window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Fehler', description: 'Fehler beim Erstellen!'});
            console.log(error)
        })

    },
    openViewModal: function(row){
        this.currentRow = row;
        this.storeEventId = row.item.id;
        
        this.showModal('modal-viewstoreevent');
    },
    openEditModal: function(row){
        this.currentrow = row;
        this.storeEventId = row.item.id;
        this.storeEvent.id = row.item.id;
        this.storeEvent.name = row.item.name;
        this.storeEvent.federalHoliday = row.item.federalHoliday;
        this.storeEvent.bankHoliday = row.item.bankHoliday;
        this.storeEvent.description = row.item.description;
        this.storeEvent.fromDate = this.$helpers.getMomentFromString(row.item.from).format("YYYY-MM-DD");
        this.storeEvent.fromTime = this.$helpers.getMomentFromString(row.item.from).format("HH:mm");
        this.storeEvent.toDate = this.$helpers.getMomentFromString(row.item.to).format("YYYY-MM-DD");
        this.storeEvent.toTime = this.$helpers.getMomentFromString(row.item.to).format("HH:mm");

        this.showModal('modal-editstoreevent');
    },
    editStoreEvent: function(evt){
        evt.preventDefault();
        
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
          id: this.storeEventId,
          name: this.storeEvent.name,
          from: this.$helpers.convertLocalDateTimeString(this.storeEvent.fromDate, this.storeEvent.fromTime),
          to: this.$helpers.convertLocalDateTimeString(this.storeEvent.toDate, this.storeEvent.toTime),
          federalHoliday: this.storeEvent.federalHoliday,
          bankHoliday: this.storeEvent.bankHoliday,
          description: this.storeEvent.description,
          updateFields: ["name", "from", "to", "federalHoliday", "bankHoliday", "description"]
        };

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            const index = view.storeevents.findIndex(event => event.id === view.storeEventId) // find the businessunit index 
            if (~index) {
                view.storeevents[index].name = payload.name;
                view.storeevents[index].from = payload.from;
                view.storeevents[index].to = payload.to;
                view.storeevents[index].federalHoliday = payload.federalHoliday;
                view.storeevents[index].bankHoliday = payload.bankHoliday;
                view.storeevents[index].description = payload.description;
            }   
            
           
            let storeEventMapItem = view.storeEventMap[view.storeEventId];

            if(storeEventMapItem != undefined){
                for (let property in payload) {
                    if (payload.hasOwnProperty(property) && storeEventMapItem.hasOwnProperty(property)) {
                        storeEventMapItem[property] = payload[property];
                    }
                }
            }
            view.hideModal('modal-editstoreevent');
        }).catch(function (error) {
            window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Fehler', description: 'Fehler beim Update!'});
            console.log(error)
        })

    },
    activateStoreEvent: function(id){
        
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
          id: id,
          active: true,
          updateFields: ["active"]
        };

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            const index = view.storeevents.findIndex(event => event.id === id) // find the businessunit index 
            if (~index) {
                view.storeevents[index].active = true;   
            }   
            view.storeEventMap[id].active = true;
        }).catch(function (error) {
            window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Fehler', description: 'Fehler beim Aktivieren!'});
            console.log(error)
        })

    },
    deactivateStoreEvent: function(id){
        
        
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
          id: id,
          active: false,
          updateFields: ["active"]
        };

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            const index = view.storeevents.findIndex(event => event.id === id) // find the businessunit index 
            if (~index) {
                view.storeevents[index].active = false;   
            }   
            view.storeEventMap[id].active = false;
        }).catch(function (error) {
            window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Fehler', description: 'Fehler beim Deaktivieren!'});
            console.log(error)
        })

    },
    openDeleteModal: function(row){
        this.currentrow = row;
        this.storeEventId = row.item.id;
        this.showModal('modal-deletestoreevent');
    },
    deleteStoreEvent: function(evt){
        evt.preventDefault();
        
        let view = this;
        let url = '/api/sec/storeevent';
        
        let params =  {
            id: this.storeEventId,
            storeId: this.$store.state.storeId
        }
       
        
        this.axios({
            method: 'delete',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            
            delete view.storeEventMap[view.storeEventId]; 
            const index = view.storeevents.findIndex(bu => bu.id === view.storeEventId) // find the businessunit index 
            if (~index) {
                view.storeevents.splice(index, 1);
            }   
             
            view.hideModal('modal-deletestoreevent');
        }).catch(function (error) {
            window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Fehler', description: 'Fehler beim Löschen!'});
            console.log(error)
        })

    },
    multiDeleteStoreEvent: function(evt){
        evt.preventDefault();
        
        let view = this;
        let url = '/api/sec/storeevent/any/delete';
        
       
        let params = {
            storeId: this.$store.state.storeId
        }
        
        let payload = {ids: []};
        this.selectedStoreEvents.forEach(item => payload.ids.push(item.id));
        
        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {

            view.refresh();
            view.hideModal('modal-deletemultistoreevent'); 
        }).catch(function (error) {
            window.app.popupmessages.push({timer: 5000, type: 'error', header: 'Fehler', description: 'Fehler beim Löschen!'});
            console.log(error)
        })

    },
    loadStoreEvents : function() {
        let view = this;
        let url = '/api/sec/storeevent';
       
        let params = {
            storeId: this.$store.state.storeId,
            from: this.$store.state.rosterFromTo.from,
            to: this.$store.state.rosterFromTo.to,
        }
      
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
            url: url
        })
        
        
    },
    
    updateStoreEvents: function(data) {
        let tevents = [];
        let tMap = {};
        for (let i = 0; i < data.length; i++) { 
            tevents.push(data[i]);
            tMap[data[i].id] = data[i];
           
        }
      
        this.storeevents = tevents;
        this.storeEventMap = tMap;
    },
    hideModal (ref) {
       
        
        this.storeEvent= {
          name: "",
          fromDate: null,
          fromTime: null,
          toDate: null,
          toTime: null,
          federalHoliday: false,
          bankHoliday: false,
          active: true,
          desription: ""
        };
        this.currentrow={};
        
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },

}
</script>

<style scoped>

</style>
